import(/* webpackMode: "eager" */ "D:\\orion-nextjs\\orion-nextjs\\src\\app\\InspectNAU-Privacy-Policy\\page.js");
